import { NgModule } from '@angular/core';
import { formatNumber } from '@angular/common';
import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalConfirmActionComponent } from 'src/app/app-layout/modal-confirm-action/modal-confirm-action.component';
import { LocalStorageKeyEnum } from 'src/app/localStorage.key.enum';
import { UserPersonSharedService } from 'src/app/services/shared/user/person/sharedPerson.service';
@Component({
  selector: 'apc-mono-action-buttons',
  templateUrl: './mono-actions.component.html',
  styleUrls: ['../action-buttons.component.scss'],
})
export class SemiActionsComponent implements OnInit {
  @Output() editEvent = new EventEmitter<boolean>(false);
  @Output() saveEvent = new EventEmitter<boolean>(false);
  @Output() cancelEvent = new EventEmitter<boolean>(false);
  @Output() deleteEvent = new EventEmitter<boolean>(false);
  @Output() readDisable = new EventEmitter<boolean>(false);
  @Output() navigateToEvent = new EventEmitter<boolean>(false);  
  @Input() disableSave: boolean = false;
  @Input() hideExtraFields: boolean = false;
  @Input() pertinence: string;
  @Input() section: string;
  @Input() subsection: string;
  @Input() personaSubsectionIdentifier: string;
  @Input() personaIdentifier: string;
  @Input() deleteItem: boolean = false;
  @Input() form: any;
  @Input() formId: string;
  @Input() navigation: string;
  @Input() disableNavigation: boolean = false;


  public permissionHistory: Object = "";
  public permissionEdit: Object = "";
  public isArchived: boolean = false;


  @Input() edit: boolean = false;

  constructor(private modalService: NgbModal, private userPersonSharedService: UserPersonSharedService) { }

  ngOnInit(): void {
    let isAdmin = false;
    if(localStorage.getItem(LocalStorageKeyEnum.PERMISSIONS)!==null){
      isAdmin = JSON.parse(localStorage.getItem(LocalStorageKeyEnum.PERMISSIONS)).role == 'Admin';
    }
    
    this.userPersonSharedService.isArchived$.subscribe(e=>{ this.isArchived = !e});

    this.permissionHistory = isAdmin ? null : { pertinence: this.pertinence, section: this.section, subsection: this.subsection, context: 'history', type: 'READER' }
    this.permissionEdit = isAdmin ? null : { pertinence: this.pertinence, section: this.section, subsection: this.subsection, context: 'metadata', type: 'EDITOR' }
  }

  editForm(disa: boolean, e?: any) {
    if(!disa) this.readDisable.emit(false);
    var headerHeight = document.getElementById("top-header") && document.getElementById("top-header").clientHeight;
    var navHeight = document.getElementById("navbar-big") && document.getElementById("navbar-big").clientHeight;
    var heightToScroll: any = headerHeight + navHeight + 46;
    this.edit = !this.edit;
    setTimeout(() => {
      e && window.scrollTo({ top: (e.pageY - heightToScroll), behavior: 'smooth' });
    }, 100);
    this.editEvent.emit(this.edit);
  }

  saveForm() {
    this.readDisable.emit(true);
    this.saveEvent.emit(true);
  }

  cancelForm() {
    if (this.form?.dirty) {
      const modalRef = this.modalService.open(ModalConfirmActionComponent);
      modalRef.componentInstance.message = 'modals.message.undoChangesMessage';
      modalRef.result.then(result => {
        if (result){
          this.confirmCancelForm();
        }
      });
    }
    else {
      this.confirmCancelForm();
    }
  }

  confirmCancelForm() {
    this.cancelEvent.emit(true);
    this.readDisable.emit(true);
    this.editForm(true);
  }

  delete() {
    this.deleteEvent.emit(true);
  }

}
